import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@material-ui/core";

import PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";
import TableGeneric from "../../../compartidos/abms/TableGeneric";
import { getTrackingLineaComprobante } from "../../../../actions/liquidaciones/liquidaciones";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      name={index}
      {...other}
    >
      {value === index && <Box p={2}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const optionsfecha = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: '2-digit',
  minute: '2-digit'
};

export const ModalTrackingLineaComprobante = (props) => {
  const dispatch = useDispatch();

  const { trackingLineaComprobante } = useSelector((state) => state.liquidaciones);
  const { open, idComprobante, idItem, idTipoLinea } = props;

  const componentRef = React.useRef();

  useEffect(() => dispatch(getTrackingLineaComprobante(idComprobante, idItem, idTipoLinea)), [open]);

  return (
    <Dialog
      fullWidth
      maxWidth="md"
      open={open}
      onClose={props.closeModalHandler}
    >
      <DialogTitle>Historial de Cambios Línea Comprobante</DialogTitle>
      <DialogContent>
        {Array.isArray(trackingLineaComprobante) && trackingLineaComprobante.length > 0 ? (
          <TableGeneric
            ref={componentRef}
            data={trackingLineaComprobante}
            columns={[
              {
                label: "Fecha",
                id: "fecha",
                sort: true,
                customBody: (item) => `${
                  new Date(item.fecha).toLocaleString(
                  "es",
                  optionsfecha
                )}`
              },
              {
                label: "Usuario",
                id: "usuario",
                customBody: (item) => `${item.usuario}`
              },
              {
                label: "Campo",
                id: "campo",
                customBody: (item) => `${item.campo}`
              },
              {
                label: "Valor Anterior",
                id: "valorAnterior",
                sort: true,
                customBody: (item) => (
                  <Typography style={{ color: "red", fontWeight: "bold" }}>
                    {item.valorAnterior}
                  </Typography>
                )
              },
              {
                label: "Valor Nuevo",
                id: "valorNuevo",
                sort: true,
                customBody: (item) => (
                  <Typography style={{ color: "green", fontWeight: "bold" }}>
                    {item.valorNuevo}
                  </Typography>
                )
              }
            ]}
          />
        ) : (
          <Typography style={{ fontStyle: "italic", fontSize: "1.1rem" }}>
            No hay datos
          </Typography>
        )}
      </DialogContent>
    </Dialog>
  );
};
